import type { ReactNode } from "react";

interface TagPillProps {
  children: ReactNode;
  variant?: "primary" | "accent" | "secondary" | "outline";
  className?: string;
}

const variants: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800 border border-primary-200/70",
  accent: "bg-accent-100 text-accent-900 border border-accent-300/60",
  secondary: "bg-secondary-100 text-secondary-900 border border-secondary-200/70",
  outline: "bg-transparent text-foreground-600 border border-background-300",
};

export default function TagPill({ children, variant = "secondary", className = "" }: TagPillProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium whitespace-nowrap ${variants[variant]} ${className}`}
    >
      {children}
    </span>
  );
}